/**
 * Maps LLM { message, ui } response to SystemMessage content[] array.
 * ui.type: chips | card_select | inline_form | confirmation_summary | locked | none
 */
export function llmResponseToContent ({ message, ui }) {
  const content = []

  if (message) {
    content.push({ type: 'text', value: message })
  }

  if (!ui || ui.type === 'none' || ui.type === 'locked') {
    return content
  }

  switch (ui.type) {
    case 'chips':
      content.push({ type: 'chips', items: ui.options || [] })
      break

    case 'multi_chips':
      content.push({
        type: 'multi_chips',
        items: ui.options || [],
        confirmButton: ui.confirmButton || 'Confirm'
      })
      break

    case 'card_select':
      content.push({
        type: 'cards',
        items: (ui.options || []).map(o =>
          typeof o === 'string' ? { title: o } : o
        ),
        confirmButton: ui.confirmButton || 'Confirm selection'
      })
      break

    case 'partial_summary': {
      const data = ui.data || {}
      const configItems = Object.entries(data)
        .filter(([, value]) => value && String(value).trim() && value !== 'Not specified' && value !== 'None provided')
        .map(([label, value]) => ({
          label,
          value: Array.isArray(value) ? value.join(', ') : String(value)
        }))
      if (configItems.length) {
        content.push({ type: 'config', items: configItems })
      }
      const chipItems = (ui.chips && ui.chips.length) ? ui.chips : (ui.options && ui.options.length ? ui.options : [])
      if (chipItems.length) {
        if (ui.multiChips) {
          content.push({ type: 'multi_chips', items: chipItems, confirmButton: ui.confirmButton || 'Confirm' })
        } else {
          content.push({ type: 'chips', items: chipItems })
        }
      }
      break
    }

    case 'confirmation_summary': {
      if (ui.defaults && ui.defaults.length) {
        content.push({ type: 'badge-row', items: ui.defaults })
      }
      const data = ui.data || {}
      content.push({
        type: 'config',
        items: Object.entries(data).map(([label, value]) => ({
          label,
          value: Array.isArray(value) ? value.join(', ') : String(value)
        }))
      })
      if (ui.journeyDefaults && ui.journeyDefaults.length) {
        ui.journeyDefaults.forEach(jd => {
          content.push({ type: 'text', value: `**Journey defaults (${jd.journey_name}):**` })
          content.push({ type: 'badge-row', items: jd.items || [] })
        })
      }
      content.push({
        type: 'buttons',
        items: ui.buttons || [
          { label: 'Yes — all correct', value: 'yes', variant: 'primary' },
          { label: 'Change something', value: 'change', variant: 'outline' }
        ]
      })
      break
    }

    case 'inline_form':
      content.push({
        type: 'form',
        fields: ui.fields || [],
        button: ui.button || 'Save & continue'
      })
      break

    default:
      break
  }

  return content
}



// WEBPACK FOOTER //
// ./src/components/entry-points/create-new-entry-point/chat-panel/llmResponseToContent.js